module.exports = __webpack_public_path__ + "static/img/DLD_Pic.f48a2a6.png";